import * as t from 'io-ts';
import { MsAgoInterface, NumberInterface, StringArrayInterface, StringInterface } from './interface';
var FieldBase = t.type({
  field: t.string
});
export var Field = t.union([t.exact(t.intersection([FieldBase, StringInterface])), t.exact(t.intersection([FieldBase, NumberInterface])), t.exact(t.intersection([FieldBase, StringArrayInterface])), t.exact(t.intersection([FieldBase, MsAgoInterface]))], 'Field');
var CustomFieldBase = t.type({
  custom_field_id: t.string
});
export var CustomField = t.union([t.exact(t.intersection([CustomFieldBase, StringInterface])), t.exact(t.intersection([CustomFieldBase, StringArrayInterface]))], 'CustomField');
export var Group = t.strict({
  group_id: t.string
}, 'Groups');
export var Leaf = t.union([Field, CustomField, Group], 'Leaf');